module.exports = __webpack_public_path__ + "img/ico-zoom-in.a12b3c62.svg";